import { TimerIconData } from "@meiden-connect/material-symbols";
import { Icon } from "@meiden-connect/ui";
import { useEffect } from "react";
import { useCanvasTimerStore } from "./canvas-timer-store";

/** タイマー終了の視覚通知を自動的に取り下げるまでの時間。 */
export const CANVAS_TIMER_FINISH_ALERT_DURATION_MS = 8_000;

/** 終了と偶然重なった入力で通知が即座に消えないようにする猶予。 */
export const CANVAS_TIMER_FINISH_ALERT_DISMISS_GRACE_MS = 600;

/** 共有タイマーが 0 へ到達した瞬間を伝える、一過性の全画面表示。 */
export function CanvasTimerFinishAlert(): JSX.Element | null {
  const finishAlert = useCanvasTimerStore((state) => state.finishAlert);
  const dismissFinishAlert = useCanvasTimerStore((state) => state.dismissFinishAlert);
  const startedAtEpochMs = finishAlert?.startedAtEpochMs;

  useEffect(() => {
    if (startedAtEpochMs === undefined) return undefined;
    const elapsedMs = Date.now() - startedAtEpochMs;
    const timeoutId = window.setTimeout(
      dismissFinishAlert,
      Math.max(0, CANVAS_TIMER_FINISH_ALERT_DURATION_MS - elapsedMs)
    );
    return () => window.clearTimeout(timeoutId);
  }, [dismissFinishAlert, startedAtEpochMs]);

  useEffect(() => {
    if (startedAtEpochMs === undefined) return undefined;

    const dismissOnInteraction = (): void => dismissFinishAlert();
    const elapsedMs = Date.now() - startedAtEpochMs;
    const graceTimeoutId = window.setTimeout(
      () => {
        window.addEventListener("pointerdown", dismissOnInteraction, true);
        window.addEventListener("keydown", dismissOnInteraction, true);
      },
      Math.max(0, CANVAS_TIMER_FINISH_ALERT_DISMISS_GRACE_MS - elapsedMs)
    );

    return () => {
      window.clearTimeout(graceTimeoutId);
      window.removeEventListener("pointerdown", dismissOnInteraction, true);
      window.removeEventListener("keydown", dismissOnInteraction, true);
    };
  }, [dismissFinishAlert, startedAtEpochMs]);

  if (!finishAlert) return null;

  return (
    <div
      className="canvas-timer-finish-alert"
      data-testid="canvas-timer-finish-alert"
      aria-hidden="true"
    >
      <div className="canvas-timer-finish-alert-ring" />
      <div className="canvas-timer-finish-alert-banner">
        <Icon d={TimerIconData} />
        <strong>時間終了</strong>
        <span>タイマーが 0 になりました</span>
      </div>
    </div>
  );
}
